import styled from 'styled-components'

export const CancerCenters = styled.div`
  .headline-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding-bottom: 20px;
    align-content: center;

    > span:first-child {
      margin-right: 10px;
    }

    .tooltip {
      position: relative;
      top: 2px;
    }
  }

  .cert-container > img {
    margin-bottom: 10px;
    display: block;
    width: auto;
    height: 40px;
    max-width: 100%;

    @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
      height: 70px;
    }
  }
`
